import { Component } from "react";
import { connect } from "react-redux";

import { Input } from "components/input/Input";
import { PrimaryArrowButton } from "components/button/Button";
import { Loader } from "components/loader/Loader";
import Dropdown from "components/dropdown/Dropdown";

class AssignmentManagerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterText: "",
      selectedBusinessUnit: ""
    };
  }

  handleChange = (e) => {
    this.setState({
      filterText: e.target.value
    });
  };

  handleBusinessUnitChange = (selectedOption) => {
    this.setState({
      selectedBusinessUnit: selectedOption.value
    });
  };

  render() {
    const sortedAssignmentManagers = this.props.assignmentManagerList.sort(
      (a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    );

    const businessUnits = this.props.assignmentManagerList
      .map((x) => {
        return x.businessUnit;
      })
      .sort()
      .filter((value, index, array) => array.indexOf(value) === index);
    const businessUnitOptions = businessUnits.map((x) => {
      return { value: x, label: x };
    });

    return (
      <div>
        {businessUnitOptions.length > 0 && (
          <div className={"d-flex justify-content-between"}>
            <h3 className={"m-0"}>Välj affärsenhet</h3>
            <div className="d-flex w-50 min-w-350" style={{ height: "3em" }}>
              <Dropdown
                className={"w-100"}
                isClearable={false}
                isSearchable={false}
                options={businessUnitOptions}
                value={this.props.category1Id}
                placeholder={"Välj affärsenhet"}
                onChange={this.handleBusinessUnitChange.bind(this)}
              />
            </div>
          </div>
        )}
        {sortedAssignmentManagers.length !== 0 && (
          <div className={"d-flex justify-content-between"}>
            <h3 className={"m-0"}>Välj uppdragsansvarig</h3>
            <div className="d-flex w-50 min-w-350" style={{ height: "3em" }}>
              <Input
                placeholder={"Sök uppdragsansvarig"}
                variant="rounded"
                onChange={this.handleChange}
                value={this.state.filterText}
              />
            </div>
          </div>
        )}

        <div className="table-wrapper">
          <table className="min-w-400">
            <thead>
              <tr key={"headerRow"}>
                <td>
                  <strong>Namn</strong>
                </td>
                <td>
                  <strong>Affärsenhet</strong>
                </td>
                <td />
              </tr>
            </thead>
            <tbody>
              {sortedAssignmentManagers.map((manager, index) => {
                const isMatchingName = manager.name
                  .toLowerCase()
                  .includes(this.state.filterText.toLowerCase());
                const isMatchingBusinessUnit =
                  this.state.selectedBusinessUnit === "" ||
                  manager.businessUnit === this.state.selectedBusinessUnit;
                if (!isMatchingName || !isMatchingBusinessUnit) {
                  return <></>;
                }

                return (
                  <tr key={index}>
                    <td>{manager.name}</td>
                    <td>{manager.businessUnit}</td>
                    <td className={"text-right"}>
                      <PrimaryArrowButton
                        size={"sm"}
                        onClick={() => this.props.onSelectManager(manager)}
                      >
                        Välj
                      </PrimaryArrowButton>
                    </td>
                  </tr>
                );
              })}

              {sortedAssignmentManagers.length === 0 && (
                <tr>
                  <td className={"p-4"}>Inga uppdragsansvariga.</td>
                </tr>
              )}
            </tbody>
          </table>

          {this.props.gettingAssignmentManagerList && (
            <Loader className={"p-4"} />
          )}
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    assignmentManagerList: state.invoices.assignmentManagerList,
    gettingAssignmentManagerList: state.invoices.gettingAssignmentManagerList
  };
})(AssignmentManagerList);
